import { useIntl } from 'react-intl';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import { navigateToMyFiles } from 'router/history';

import { DocumentTitle, ErrorView, IntlErrorBoundary, Sidebar } from '_common/components';
import GroupsPage from './pages/GroupsPage/GroupsPage';

import styles from './GroupsContainer.module.scss';

const GroupsContainer = () => {
  const intl = useIntl();
  const match = useRouteMatch();
  return (
    <div className={styles.root}>
      <Sidebar />
      <Switch>
        <Route exact path={match.path}>
          <DocumentTitle
            title={`doDOC - ${intl.formatMessage({
              id: 'storage.sidebar.groups',
            })}`}
          >
            <IntlErrorBoundary size="large" margin="21rem auto 0 auto">
              <GroupsPage />
            </IntlErrorBoundary>
          </DocumentTitle>
        </Route>
        <Route path="*">
          <ErrorView
            error={{
              status: 404,
            }}
            onClick={navigateToMyFiles}
          />
        </Route>
      </Switch>
    </div>
  );
};

export default GroupsContainer;
